import React from 'react';
import { useSelector } from 'react-redux';
import RefForm from '../../../components/RefForm/RefForm';
import "./style.scss";

function AddRef() {
  const user = useSelector((state) => state.auth?.user?.data);

  if (user?.role_id !== 1) {
    return "Your are not authorized to view this page";
  }
    
  return (
    <div>
        <RefForm reference={null} />
    </div>
  );
}

export default AddRef
